const SET_SEARCH = 'SET_SEARCH';
const ADD_MORE_PRODUCTS = 'ADD_MORE_PRODUCTS';

export {
    SET_SEARCH, ADD_MORE_PRODUCTS
};
